import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/services';
import { useSuperAdminApiOverrides } from '../superAdmin';
import { ServiceRequestType } from 'src/models/serviceRequest';

type CreateServiceRequestTypePayload = Pick<
  ServiceRequestType,
  'service_request_type' | 'service_request_key' | 'initial_status'
>;

export const useCreateServiceRequestType = () => {
  const { headers } = useSuperAdminApiOverrides();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['createServiceRequestType'],
    mutationFn: (payload: CreateServiceRequestTypePayload) => {
      return api
        .post<ServiceRequestType>('/v3/service_request/types', payload, {
          headers,
        })
        .then((res) => res.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['serviceRequestTypes'] });
    },
  });
};
